import { render } from "./UnitTabs.vue?vue&type=template&id=54877133&scoped=true"
import script from "./UnitTabs.vue?vue&type=script&lang=js"
export * from "./UnitTabs.vue?vue&type=script&lang=js"

import "./UnitTabs.vue?vue&type=style&index=0&id=54877133&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54877133"]])

export default __exports__